import { type PageContent } from '../../../containers/embedded-page/types';
import { type BlueprintData } from '../../../state/ui/blueprints/types';

export type Cohort = 'not-enrolled' | 'control' | 'variation';

export type ExperimentVariant = 'aa' | 'ab';

export type CreateEmbeddedPage = (
	parentContentId: string | undefined,
	isRoot: boolean,
	blueprint?: BlueprintData,
	content?: PageContent,
) => Promise<void>;

export const BLANK_PAGE = 'blankPage';
